import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConferenciaVolumeComponent } from 'src/app/@pages/conferencia-volume/conferencia-volume.component';
import { ContagemInventarioComponent } from 'src/app/@pages/contagem-inventario/contagem-inventario.component';
import { InventarioCapaContagemComponent } from 'src/app/@pages/inventario-capa-contagem/inventario-capa-contagem.component';
import { InventarioContagemItensComponent } from 'src/app/@pages/inventario-contagem-itens/inventario-contagem-itens.component';
import { EstoqueConsolidadoComponent } from 'src/app/@pages/paineldecontrole/estoque/estoque-consolidado/estoque-consolidado.component';
import { ExtratoEstoqueComponent } from 'src/app/@pages/paineldecontrole/estoque/extrato-estoque/extrato-estoque.component';
import { ExtratoImportacaoComponent } from 'src/app/@pages/paineldecontrole/extrato-importacao/extrato-importacao.component';
import { RedirecionamentoExternoComponent } from 'src/app/@pages/redirecionamento-externo/redirecionamento-externo.component';
import { ParametrizacaoLimitesComponent } from 'src/app/@pages/risco/parametrizacao-limites/parametrizacao-limites.component';
import { RelatorioRiscoGaiolaComponent } from 'src/app/@pages/risco/relatorio-risco-gaiola/relatorio-risco-gaiola.component';
import { PainelControleRiscoComponent } from 'src/app/@pages/risco/painel-controle-risco/painel-controle-risco.component';
import { ReentregaLoteComponent } from 'src/app/@pages/reentrega-lote/reentrega-lote.component';
import { ReentregaLoteConsultaComponent } from 'src/app/@pages/reentrega-lote/reentrega-lote-consulta/reentrega-lote-consulta.component';
import { StatusParaSfxComponent } from 'src/app/@pages/status-para-sfx/status-para-sfx.component';
import { ImportacoesComponent } from 'src/app/@pages/importacoes/importacoes.component';
import { AuthGuard } from 'src/app/@core/guards/auth.guard';
import { AppDefaultComponent } from 'src/app/@core/app-default/app-default/app-default.component';
import { AppBlankComponent } from 'src/app/@core/app-blank/app-blank/app-blank.component';
import { GestaoDeCteComponent } from '../documentos-fiscais/gestao-de-cte/gestao-de-cte.component';
import { tipoAcao } from 'src/app/@shared/models/gestao-de-cte/gestao-de-cte.model';
import { AppImmersiveComponent } from 'src/app/@core/app-immersive/app-immersive/app-immersive.component';
import { ManutencaoEnvioCteComponent } from '../cadastro/cadastros/manutencao-envio-cte/manutencao-envio-cte.component';
import { ListaGerenciaArquivoComponent } from '../gerencia-arquivo/lista-gerencia-arquivo/lista-gerencia-arquivo.component';
import { CadastraArquivoGerenciaComponent } from '../gerencia-arquivo/cadastra-arquivo-gerencia/cadastra-arquivo-gerencia.component';
import { ControleExpedicaoMalhaComponent } from '../relatorios/relatorios/controle-expedicao-malha/controle-expedicao-malha.component';
import { ManifestoEmbarquePainelCteComponent } from '../manifesto-embarque/manifesto-embarque/manifesto-embarque-painel-cte/manifesto-embarque-painel-cte.component';
import { ManifestosPainelComponent } from '../manifesto-transferencia/manifesto-transferencia/manifestos-painel/manifestos-painel.component';
import { ManifestoEmbarquePainelComponent } from '../manifesto-embarque/manifesto-embarque/manifesto-embarque-painel/manifesto-embarque-painel.component';
import { ConsultaDetalheComponent } from '../consulta-detalhada/consulta-detalhada/consulta-detalhe/consulta-detalhe.component';
import { ConsultaDetalhadaInternaComponent } from '../consulta-detalhada/consulta-detalhada/consulta-detalhada-interna/consulta-detalhada-interna.component';
import { PreLotesComponent } from '../documentos-fiscais/gestao-de-cte/pre-lotes/pre-lotes.component';
import { LotesComponent } from '../documentos-fiscais/gestao-de-cte/lotes/lotes.component';
import { ComplementoFaturaCteComponent } from '../consultas/consultas/complemento-fatura-cte/complemento-fatura-cte.component';
import { AcompanhamentoCorrecoesErrosCteComponent } from '../documentos-fiscais/acompanhamento-correcoes-erros-cte/acompanhamento-correcoes-erros-cte.component';
import { FiltroModeloGaragensComponent } from '../garagem/modelo/filtro-modelo-garagens/filtro-modelo-garagens.component';
import { RelatorioAcompanhamentoExpedicoesComponent } from 'src/app/@pages/fae/relatorio-acompanhamento-expedicoes/relatorio-acompanhamento-expedicoes.component';
import { LoadArquivoComponent } from '../load-arquivo/load-arquivo.component';

const routes: Routes = [

  {
    path: 'outros',
    component: AppDefaultComponent,
    children: [
      {
        canActivate: [AuthGuard],
        data: { FEATURE_ID: 'outros.arquivo.lista-arquivo' }, // VERIFICAR FUNCIONAMENTO DA TELA
        path: 'arquivo/lista-arquivo',
        component: ListaGerenciaArquivoComponent
      },
      {
        canActivate: [AuthGuard],
        data: { FEATURE_ID: 'outros.arquivo.cadastro-arquivo' },
        path: 'arquivo/cadastro-arquivo',
        component: CadastraArquivoGerenciaComponent,
      },
      {
        data: { FEATURE_ID: 'outros.arquivo.carregar-arquivo-cliente-servidor' },
        path: 'arquivo/carregar-arquivo-cliente-servidor',
        component: LoadArquivoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'painel-controle',
        component: AppDefaultComponent,
        children: [
          {
            data: { FEATURE_ID: 'outros.painel-controle.estoque-consolidado' },
            path: 'estoque-consolidado',
            component: EstoqueConsolidadoComponent,
            canActivate: [AuthGuard]
          },
          {
            data: { FEATURE_ID: 'outros.painel-controle.extrato-estoque' },
            path: 'extrato-estoque',
            component: ExtratoEstoqueComponent,
            canActivate: [AuthGuard]
          },
          {
            data: { FEATURE_ID: 'outros.painel-controle.extrato-importacao' },
            path: 'extrato-importacao',
            component: ExtratoImportacaoComponent,
            canActivate: [AuthGuard]
          },
        ]
      },
      {
        path: 'risco',
        component: AppDefaultComponent,
        children: [
          {
            data: { FEATURE_ID: 'outros.risco.conferencia-volumes' },
            path: 'conferencia-volumes',
            component: ConferenciaVolumeComponent,
            canActivate: [AuthGuard]
          },
          {
            data: { FEATURE_ID: 'outros.risco.painel-risco' },
            path: 'painel-risco',
            component: PainelControleRiscoComponent,
            canActivate: [AuthGuard]
          },
          {
            data: { FEATURE_ID: 'outros.risco.parametrizacao-limites' },
            path: 'parametrizacao-limites',
            component: ParametrizacaoLimitesComponent,
            canActivate: [AuthGuard]
          },
          {
            data: { FEATURE_ID: 'outros.risco.relatorio-risco-gaiola' },
            path: 'relatorio-risco-gaiola',
            component: RelatorioRiscoGaiolaComponent,
            canActivate: [AuthGuard]
          }
        ]
      },
    
    ]
  },
  {
    path: 'paineis',
    component: AppDefaultComponent,
    children: [
      {
        data: { FEATURE_ID: 'paineis.manifesto-devolucao-transporte.painel-manifestos-devolucao-transporte'},
        path: 'manifesto-devolucao-transporte/painel-manifestos-devolucao-transporte',
        component: ManifestosPainelComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'paineis.controle-expedicao-malha' },
        path: 'controle-expedicao-malha',
        component: ControleExpedicaoMalhaComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'paineis.cte.painel-cte' },
        path: 'cte/painel-cte',
        component: ManifestoEmbarquePainelCteComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'paineis.manifesto-transferencia.painel-manifestos-transferencia' },
        path: 'manifesto-transferencia/painel-manifestos-transferencia',
        component: ManifestosPainelComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'paineis.manifesto-embarque.painel-manifesto-embarque' },
        path: 'manifesto-embarque/painel-manifesto-embarque',
        component: ManifestoEmbarquePainelComponent,
        canActivate: [AuthGuard]
      },    
    ]
  },
  {
    path: 'integracoes',
    component: AppDefaultComponent,
    children: [
      {
        data: { FEATURE_ID: 'integracoes.ultimo-status-sfx' },
        path: 'ultimo-status-para-sfx',
        component: StatusParaSfxComponent,
        // canActivate: [AuthGuard]
      }]
  },
  {
    path: 'importacoes',
    component: AppDefaultComponent,
    children: [
      {
        data: { FEATURE_ID: 'importacoes.talao-itau' },
        path: 'talao-itau',
        component: ImportacoesComponent,
        //canActivate: [AuthGuard]
      }]
  },
  {
    path: 'reentrega',
    component: AppDefaultComponent,
    children: [
      {
        data: { FEATURE_ID: 'reentrega.reentregaemlote' },
        path: 'reentregaemlote',
        component: ReentregaLoteComponent,
        // canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'reentrega.reentregaconsulta' },
        path: 'reentregaconsulta',
        component: ReentregaLoteConsultaComponent,
        // canActivate: [AuthGuard]
      },
    ]
  },
  {
    path: 'inventario',
    component: AppDefaultComponent,
    children: [
      
      {
        data: { FEATURE_ID: 'inventario.contagens' },
        path: 'contagens/:params',
        component: InventarioCapaContagemComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'inventario.contagem-itens' },
        path: 'contagem-itens',
        component: InventarioContagemItensComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'inventario.contagem-itens' },
        path: 'contagem-itens/:params',
        component: InventarioContagemItensComponent,
        canActivate: [AuthGuard]
      },
      {
        //data: { FEATURE_ID: '' },
        path: 'contagem-inventario',
        component: ContagemInventarioComponent,
        //canActivate: [AuthGuard]
      },
    ]
  },

  // TELAS DE CTE COM APPIMMERSIVECOMPONENT
  {
    path: 'gestao/cte',
    component: AppImmersiveComponent,
    children: [
      {
        data: { FEATURE_ID: 'gestao.cte.anulacao-cte', tipoAcao: tipoAcao.Anulacao },
        path: 'anulacao-cte',
        component: GestaoDeCteComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'gestao.cte.substituicao-cte', tipoAcao: tipoAcao.Substituicao },
        path: 'substituicao-cte',
        component: GestaoDeCteComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'gestao.cte.emissao-cte-complementar', tipoAcao: tipoAcao.Complementar },
        path: 'emissao-cte-complementar',
        component: GestaoDeCteComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'gestao.cte.cancelamento-cte', tipoAcao: tipoAcao.Cancelamento },
        path: 'cancelamento-cte',
        component: GestaoDeCteComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'gestao.cte.lotes-processamento' },
        path: 'pre-lote/:identificador',
        component: PreLotesComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'gestao.cte.lotes-processamento' },
        path: 'lotes-processamento',
        component: AcompanhamentoCorrecoesErrosCteComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'gestao.cte.lotes-processamento' },
        path: 'lotes-processamento/:identificador',
        component: LotesComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'gestao.cte.manutencao-envio-cte' },
        path: 'manutencao-envio-cte',
        component: ManutencaoEnvioCteComponent,
        canActivate: [AuthGuard]
      },
      {
        data: { FEATURE_ID: 'gestao.cte.complemento-fatura-cte' },
        path: 'complemento-fatura-cte',
        component: ComplementoFaturaCteComponent,
        canActivate: [AuthGuard]
      },
    ]
  },
  {
    path: 'relatorios/cte',
    component: AppImmersiveComponent,
    children: [
      {
        data: { FEATURE_ID: 'relatorios.cte.consulta-cte', tipoAcao: tipoAcao.Consulta },
        path: 'consulta-cte',
        component: GestaoDeCteComponent,
        canActivate: [AuthGuard]
      },
    ]
  },
  {
    path: 'relatorios/tracking',
    component: AppImmersiveComponent,
    children: [
       {
         data: { FEATURE_ID: 'relatorios.tracking.consulta-pedido-detalhes' },
         path: 'consulta-pedido-detalhes',
         component: ConsultaDetalheComponent,
         canActivate: [AuthGuard]
       },
       {
         data: { FEATURE_ID: 'relatorios.tracking.consulta-pedido-detalhes-interna' },
         path: 'consulta-pedido-detalhes-interna',
         component: ConsultaDetalhadaInternaComponent,
         canActivate: [AuthGuard]
       }
    ]
  },
  {
    path: 'external', // Componente para redirecionamento de acesso externo.
    component: AppBlankComponent,
    children:
      [
        {
          path: 'redirect/:hash',
          component: RedirecionamentoExternoComponent
        },
      ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class MainRoutingModule {}
